import React from 'react'
import { Icon, Button } from '@alifd/next'
import styles from './index.module.scss'

interface SubjectItemProps {
  count: string,
  name: string,
}

export default function ResearchCenter() {
  const subject: SubjectItemProps[] = [
    {
      count: '30',
      name: '国家级研究课题',
    },
    {
      count: '2,000',
      name: '呼吸领域临床医生',
    },
    {
      count: '300',
      name: '省市中心医院科室',
    },
    {
      count: '100,000',
      name: '呼吸疾病患者',
    },
  ]

  function subjectItem(props: SubjectItemProps) {
    const {count, name} = props
    return (
      <ul>
        <li>{ count }<span>+</span></li>
        <li>{ name }</li>
      </ul>
    )
  }

  return (
    <React.Fragment>
      {/* 最顶端图 */}
      <div className={ styles.researchCenter}>
        <div style={{ width: 1200, margin: 'auto', textAlign: 'center'}}>
          <h1 style={{ color: '#fff', fontSize: 48, margin: 0, paddingTop: 92, fontWeight: 400 }}>呼吸疾病临床研究大数据平台</h1>
          <div className={ styles.btn }>
            <a href="/apps/bi?name=playlist" target="_blank" rel="noopener noreferrer">
              <Button style={{ width:158, height:48, fontSize: 23 }}>立即进入<Icon type="arrow-right" size="medium" /></Button>
            </a>
          </div>
          {/* 视频 */}
          <div style={{ width: 780, height: 450, borderRadius: 25, background: '#000', margin: '0 auto' }}>
            <video id="samp" width="744" height="420" controls muted autoPlay loop style={{ marginTop: 15 }}>
              <source src="https://cdn.mediecogroup.com/uploads/zrbd.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
        {/* 研究课题数据 */}
        <div className={ styles.researchSubject } data-flex="cross:center">
          { subject.map(subjectItem) }
        </div>
      </div>
    </React.Fragment>
  )
}
